import { useNavigate } from "react-router-dom";

import { ReactComponent as ArrowBack } from "../../assets/svg/arrow-back.svg";

import styles from "./back-button.module.css";

export function BackButton() {
  const navigate = useNavigate();

  return (
    <button
      className={styles.button}
      type="button"
      aria-label="Back"
      onClick={() => navigate(-1)}
    >
      <ArrowBack width={48} height={48} title="Back" aria-hidden />
    </button>
  );
}
